/* =========================================================================
   Nakshatra Store — theme.js
   Vanilla JS only. Cart uses Shopify's native AJAX Cart API (/cart/*.js).
   ========================================================================= */
(function () {
  "use strict";

  const money = (cents) =>
    (window.Shopify && window.Shopify.formatMoney)
      ? window.Shopify.formatMoney(cents, window.themeMoneyFormat)
      : "₹" + (cents / 100).toLocaleString("en-IN");

  /* ---------------- Toast ---------------- */
  let toastTimer;
  function toast(message) {
    const el = document.getElementById("toast");
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 2600);
  }

  /* ---------------- Drawers ---------------- */
  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return;
    d.classList.add("is-open");
    document.body.style.overflow = "hidden";
    const close = d.querySelector("[data-drawer-close]");
    if (close) close.focus();
  }
  function closeDrawer(d) {
    d.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  document.addEventListener("click", (e) => {
    const opener = e.target.closest("[data-drawer-open]");
    if (opener) { e.preventDefault(); openDrawer(opener.dataset.drawerOpen); return; }
    const closer = e.target.closest("[data-drawer-close], .drawer__overlay");
    if (closer) { const d = closer.closest(".drawer"); if (d) closeDrawer(d); }
  });
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    document.querySelectorAll(".drawer.is-open").forEach(closeDrawer);
  });

  /* ---------------- Cart API ---------------- */
  async function getCart() {
    const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    return res.json();
  }

  async function addToCart(id, quantity) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) || 1 }] }),
    });
    if (!res.ok) throw new Error((await res.json()).description || "Could not add to cart");
    return res.json();
  }

  async function changeLine(line, quantity) {
  const res = await fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      line: Number(line),
      quantity: Number(quantity)
    })
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(
      data.description ||
      "Unable to update cart."
    );
  }

  return data;
}

/* ---------------- Cart rendering ---------------- */

function getFreeShippingThreshold() {
  const cartForm = document.getElementById("CartForm");

  if (cartForm) {
    return Number(
      cartForm.dataset.freeShippingThreshold || 0
    );
  }

  return Number(
    document.documentElement.dataset.freeShipping || 0
  );
}


function updateCartGlobals(cart) {

  /* Header / drawer cart count */
  document
    .querySelectorAll("[data-cart-count]")
    .forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });


  /* Subtotal */
  document
    .querySelectorAll("[data-cart-subtotal]")
    .forEach((el) => {
      el.textContent = money(cart.total_price);
    });


  /* Free shipping */
  const threshold = getFreeShippingThreshold();

  document
    .querySelectorAll("[data-free-shipping]")
    .forEach((bar) => {

      if (threshold <= 0) return;

      const remaining = Math.max(
        0,
        threshold - cart.total_price
      );

      const text =
        bar.querySelector("[data-free-shipping-text]");

      const progress =
        bar.querySelector("[data-free-shipping-bar]") ||
        bar.querySelector(".progress > span");

      if (text) {
        text.textContent =
          remaining > 0
            ? `Add ${money(remaining)} more for free shipping`
            : "🎉 You've unlocked free shipping!";
      }

      if (progress) {
        progress.style.width =
          Math.min(
            100,
            (cart.total_price / threshold) * 100
          ) + "%";
      }

    });
}


function renderCartPage(cart) {
  const form = document.getElementById("CartForm");

  if (!form) return;

  const lines = form.querySelector("[data-cart-lines]");

  if (!lines) return;

  /*
   * Update existing Liquid cart rows.
   * Match by line position instead of cart key so a Shopify
   * key change cannot make the product row disappear.
   */
  const rows = Array.from(
    lines.querySelectorAll("[data-cart-line-key]")
  );

  cart.items.forEach((item, index) => {
    const row = rows[index];

    if (!row) return;

    const input =
      row.querySelector("[data-qty-input]");

    const lineTotal =
      row.querySelector("[data-cart-line-total]");

    const price =
      row.querySelector(".cart-line__price-final") ||
      row.querySelector(".cart-line__price");

    if (input) {
      input.value = item.quantity;
    }

    if (lineTotal) {
      lineTotal.textContent =
        money(item.final_line_price);
    }

    if (price) {
      price.textContent =
        money(item.final_price);
    }

    /*
     * Keep the latest Shopify key on the row.
     */
    row.dataset.cartLineKey = item.key;

    /*
     * Keep the quantity input in sync too.
     */
    if (input) {
      input.dataset.lineKey = item.key;
    }

    row.classList.remove("is-updating");
  });

  /*
   * Remove only rows that no longer have a corresponding
   * Shopify cart item.
   */
  rows.slice(cart.items.length).forEach((row) => {
    row.remove();
  });

  updateCartGlobals(cart);

  /*
   * If cart became empty, reload only in this special case
   * so Liquid can display the proper empty-cart design.
   */
  if (cart.item_count === 0) {
    window.location.reload();
  }
}


function renderCartDrawer(cart) {

  const drawer =
    document.getElementById("cart-drawer");

  if (!drawer) return;

  const body =
    drawer.querySelector("[data-cart-lines]");

  if (!body) return;


  body.innerHTML =
    cart.items.length === 0
      ? `
        <p class="center cart-empty-message">
          Your cart is empty.
        </p>
      `
      : cart.items.map((item, i) => `

        <li
          class="card-lux cart-line"
          data-drawer-cart-line
        >

          ${
            item.image
              ? `
                <img
                  src="${item.image}"
                  alt="${escapeCartHtml(item.product_title)}"
                  width="96"
                  height="96"
                  loading="lazy"
                  class="cart-line__image"
                >
              `
              : ""
          }

          <div class="cart-line__body">

            <p class="cart-line__title">
              ${escapeCartHtml(item.product_title)}
            </p>

            <p class="cart-line__price">
              ${money(item.final_price)}
            </p>

            <div class="cart-line__footer">

              <div class="qty">

                <button
                  type="button"
                  data-line="${i + 1}"
                  data-qty="${Math.max(0, item.quantity - 1)}"
                  aria-label="Decrease quantity"
                >
                  −
                </button>

                <input
                  value="${item.quantity}"
                  readonly
                  aria-label="Quantity"
                >

                <button
                  type="button"
                  data-line="${i + 1}"
                  data-qty="${item.quantity + 1}"
                  aria-label="Increase quantity"
                >
                  +
                </button>

              </div>

              <button
                type="button"
                class="link-remove"
                data-line="${i + 1}"
                data-qty="0"
              >
                Remove
              </button>

              <span class="cart-line__line-total">
                ${money(item.final_line_price)}
              </span>

            </div>

          </div>

        </li>

      `).join("");


  updateCartGlobals(cart);
}


function escapeCartHtml(value) {

  const div =
    document.createElement("div");

  div.textContent =
    value == null ? "" : String(value);

  return div.innerHTML;
}


function renderCart(cart) {

  /*
   * Cart page has its own Liquid markup.
   * Do NOT overwrite it with drawer markup.
   */
  if (document.getElementById("CartForm")) {
    renderCartPage(cart);
  }

  /*
   * Drawer is rendered separately.
   */
  renderCartDrawer(cart);

  updateCartGlobals(cart);
}


async function refreshCart(open) {

  const cart =
    await getCart();

  renderCart(cart);

  if (open) {
    openDrawer("cart-drawer");
  }
}

  /* ---------------- Add to cart / buy now ---------------- */
  document.addEventListener("click", async (e) => {
    const btn = e.target.closest("[data-add-to-cart]");
    if (btn) {
      e.preventDefault();
      const form = btn.closest("form");
      const variantId = btn.dataset.variantId || (form && form.querySelector("[name='id']").value);
      const qtyInput = form && form.querySelector("[name='quantity']");
      const quantity = btn.dataset.quantity || (qtyInput ? qtyInput.value : 1);
      btn.disabled = true;
      try {
        await addToCart(variantId, quantity);
        const original = btn.dataset.label || btn.textContent.trim();
        btn.dataset.label = original;
        btn.textContent = "Added ✓";
        toast("Added to cart");
        await refreshCart(btn.hasAttribute("data-open-drawer"));
        setTimeout(() => { btn.textContent = original; }, 1600);
      } catch (err) {
        toast(err.message);
      } finally {
        btn.disabled = false;
      }
      return;
    }

    const buy = e.target.closest("[data-buy-now]");
    if (buy) {
      e.preventDefault();
      const form = buy.closest("form");
      const variantId = buy.dataset.variantId || form.querySelector("[name='id']").value;
      const quantity = buy.dataset.quantity || form.querySelector("[name='quantity']").value;
      buy.disabled = true;
      try {
        await addToCart(variantId, quantity);
        // window.location.href = "/checkout";
        window.location.href = "{{ routes.checkout_url }}";
      } catch (err) {
        buy.disabled = false;
        toast(err.message);
      }
      return;
    }

    /* ---------------- Cart drawer quantity ---------------- */

const qtyBtn =
  e.target.closest(
    "#cart-drawer [data-line], #cart-drawer .link-remove"
  );

if (qtyBtn && qtyBtn.dataset.line) {

  e.preventDefault();

  if (qtyBtn.disabled) return;

  qtyBtn.disabled = true;

  try {

    const cart =
      await changeLine(
        qtyBtn.dataset.line,
        qtyBtn.dataset.qty
      );

    renderCart(cart);

  } catch (err) {

    console.error(
      "Nakshatra cart drawer update error:",
      err
    );

    toast(
      err.message ||
      "Unable to update cart."
    );

  } finally {

    qtyBtn.disabled = false;

  }

  return;
}


/* ---------------- Full cart page quantity ---------------- */

const pageMinus =
  e.target.closest(
    "#CartForm [data-qty-minus]"
  );

const pagePlus =
  e.target.closest(
    "#CartForm [data-qty-plus]"
  );

const pageRemove =
  e.target.closest(
    "#CartForm [data-cart-remove]"
  );


if (pageMinus || pagePlus || pageRemove) {

  e.preventDefault();

  const button =
    pageMinus || pagePlus || pageRemove;

  const row =
    button.closest("[data-cart-line-key]");

  if (!row) return;

  const input =
    row.querySelector("[data-qty-input]");

  if (!input) return;

  const key =
    row.dataset.cartLineKey;

  let quantity =
    Number(input.value) || 1;


  if (pageMinus) {
    quantity =
      Math.max(0, quantity - 1);
  }

  if (pagePlus) {
    quantity =
      quantity + 1;
  }

  if (pageRemove) {
    quantity = 0;
  }


  /*
   * Immediate visual feedback.
   */
  row.classList.add("is-updating");

  button.disabled = true;


  try {

    const res =
      await fetch("/cart/change.js", {

        method: "POST",

        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },

        body: JSON.stringify({
          id: key,
          quantity: quantity
        })

      });


    if (!res.ok) {

      const error =
        await res.json();

      throw new Error(
        error.description ||
        "Unable to update cart."
      );

    }


    const cart =
      await res.json();

    renderCart(cart);


  } catch (err) {

    row.classList.remove("is-updating");

    console.error(
      "Nakshatra cart update error:",
      err
    );

    toast(
      err.message ||
      "Unable to update cart."
    );


  } finally {

    button.disabled = false;

  }


  return;
}
  });

  /* ---------------- Product page: quantity + variants + gallery ---------------- */
  document.querySelectorAll("[data-product-form]").forEach((form) => {
    const qtyInput = form.querySelector("[name='quantity']");
    form.querySelectorAll("[data-qty-step]").forEach((b) => {
      b.addEventListener("click", () => {
        const next = Math.max(1, Number(qtyInput.value) + Number(b.dataset.qtyStep));
        qtyInput.value = next;
        form.querySelectorAll("[data-quantity]").forEach((el) => { el.dataset.quantity = next; });
        document.dispatchEvent(new CustomEvent("quantity:change", { detail: { quantity: next } }));
      });
    });

    const select = form.querySelector("[data-variant-select]");
    if (select) {
      select.addEventListener("change", () => {
        const id = select.value;
        form.querySelector("[name='id']").value = id;
        form.querySelectorAll("[data-variant-id]").forEach((el) => { el.dataset.variantId = id; });
        const url = new URL(window.location);
        url.searchParams.set("variant", id);
        window.history.replaceState({}, "", url);
      });
    }
  });

  document.querySelectorAll("[data-gallery]").forEach((gallery) => {
    const main = gallery.querySelector("[data-gallery-main]");
    gallery.querySelectorAll("[data-gallery-thumb]").forEach((thumb) => {
      thumb.addEventListener("click", () => {
        main.src = thumb.dataset.galleryThumb;
        main.alt = thumb.dataset.alt || main.alt;
        gallery.querySelectorAll("[data-gallery-thumb]").forEach((t) => t.setAttribute("aria-current", "false"));
        thumb.setAttribute("aria-current", "true");
      });
    });
  });

  /* ---------------- Recently viewed (localStorage, ring buffer of 12) ---------- */
  const RV_KEY = "nakshatra:recently-viewed";
  function readRV() {
    try { return JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (e) { return []; }
  }
  const current = document.body.dataset.productHandle;
  if (current) {
    const next = [current].concat(readRV().filter((h) => h !== current)).slice(0, 12);
    try { localStorage.setItem(RV_KEY, JSON.stringify(next)); } catch (e) { /* storage blocked */ }
  }
  const rvSection = document.querySelector("[data-recently-viewed]");
  if (rvSection) {
    const handles = readRV().filter((h) => h !== current).slice(0, 6);
    if (handles.length === 0) {
      rvSection.remove();
    } else {
      const target = rvSection.querySelector("[data-recently-viewed-grid]");
      Promise.all(handles.map((h) =>
        fetch(`/products/${h}?view=card`).then((r) => (r.ok ? r.text() : "")).catch(() => "")
      )).then((cards) => {
        const html = cards.filter(Boolean).join("");
        if (html) { target.innerHTML = html; rvSection.hidden = false; }
        else rvSection.remove();
      });
    }
  }

  /* ---------------- Scroll reveal ---------------- */
  const io = "IntersectionObserver" in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) { entry.target.classList.add("is-visible"); io.unobserve(entry.target); }
        });
      }, { rootMargin: "0px 0px -8% 0px" })
    : null;
  document.querySelectorAll(".reveal").forEach((el) => (io ? io.observe(el) : el.classList.add("is-visible")));

  /* ---------------- Boot ---------------- */
  /* ---------------- Boot ---------------- */

document.addEventListener(
  "DOMContentLoaded",
  () => {

    /*
     * The cart page is already server-rendered by Liquid.
     * Do not fetch and redraw it on initial load.
     */
    if (document.getElementById("CartForm")) {
      return;
    }

    /*
     * Other pages may need the cart drawer synced.
     */
    if (document.getElementById("cart-drawer")) {
      refreshCart(false);
    }

  }
);
})();